import { render, staticRenderFns } from "./Form51WeeklyMenu.vue?vue&type=template&id=2dfbd55f&scoped=true&"
import script from "./Form51WeeklyMenu.vue?vue&type=script&lang=js&"
export * from "./Form51WeeklyMenu.vue?vue&type=script&lang=js&"
import style0 from "./Form51WeeklyMenu.vue?vue&type=style&index=0&id=2dfbd55f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbd55f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFlex,VLayout,VSelect})
